import { Camera, Eye, Sparkles, ChevronRight } from 'lucide-react';

const HowItWorksSectionB = () => {
  const steps = [
    {
      number: "1",
      icon: Camera,
      title: "Start a Home Safety Scan",
      description: "Point your phone's camera at any room. It's as easy as taking a family picture."
    },
    {
      number: "2",
      icon: Eye,
      title: "See Hidden Risks",
      description: "Powered by ThriveVision to spot risks early—like loose rugs, poor lighting, or clutter."
    },
    {
      number: "3",
      icon: Sparkles,
      title: "Get Easy Fixes",
      description: "Receive clear, practical suggestions to make your home safer right away."
    }
  ];

  return (
    <section className="py-16 lg:py-20">
      {/* Section Header */}
      <div className="text-center mb-14">
        <h2 className="text-3xl lg:text-4xl font-bold text-foreground mb-3 tracking-tight">
          Home Safety Scan
        </h2>
        <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
          Powered by ThriveVision to spot risks and suggest simple fixes—right from your phone or tablet.
        </p>
      </div>
      
      {/* Steps */}
      <div className="max-w-4xl mx-auto">
        <div className="grid md:grid-cols-3 gap-8 md:gap-4">
          {steps.map((step, index) => (
            <div key={step.number} className="relative">
              {/* Step Card */}
              <div className="text-center group">
                {/* Icon with number */}
                <div className="relative w-20 h-20 mx-auto mb-5">
                  <div className="w-full h-full bg-gradient-to-br from-primary/15 to-primary/5 rounded-2xl flex items-center justify-center border border-primary/15 group-hover:border-primary/30 transition-colors">
                    <step.icon className="w-9 h-9 text-primary" strokeWidth={1.5} />
                  </div>
                  {/* Number badge */}
                  <div className="absolute -top-2 -left-2 w-7 h-7 bg-primary rounded-lg flex items-center justify-center text-primary-foreground font-bold text-sm shadow-md">
                    {step.number}
                  </div>
                </div>
                
                <h3 className="text-lg font-semibold mb-2 text-foreground">{step.title}</h3>
                <p className="text-muted-foreground text-sm leading-relaxed max-w-[220px] mx-auto">{step.description}</p>
              </div>
              
              {/* Arrow connector - desktop only */}
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-10 -right-4 z-10">
                  <ChevronRight className="w-5 h-5 text-primary/30" />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSectionB;
